export default __webpack_public_path__ + "static/media/more.7b134dc9.svg";